import type {
  ProjectDescriptionEntropyCompletionPostPayload,
  ProjectDescriptionEntropyCompletionResult,
} from './project-description-entropy-completion.backend-model';
import type { ProjectDescriptionEntropyCompletion } from './project-description-entropy-completion.model';

export function transformProjectDescriptionEntropyCompletion(
  response: ProjectDescriptionEntropyCompletionResult,
  request: ProjectDescriptionEntropyCompletionPostPayload,
): ProjectDescriptionEntropyCompletion {
  return {
    id: request.id,
    question: request.question,
    answer: request.answer,
    sentenceToComplete: request.sentenceToComplete,
    completion: response.completion,
  };
}
